import { render } from "./EditPopup.vue?vue&type=template&id=73631708&scoped=true"
import script from "./EditPopup.vue?vue&type=script&lang=js"
export * from "./EditPopup.vue?vue&type=script&lang=js"

import "./EditPopup.vue?vue&type=style&index=0&id=73631708&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73631708"]])

export default __exports__